import nipplejs from 'nipplejs';
import { InputManager } from '../utils/InputManager';

/**
 * スマートフォン用タッチ操作UI
 * - 左: nipplejs バーチャルジョイスティック（機首操作）
 * - 右: アクションボタン（バルカン・ミサイル・ブースト・ポーズ）
 * - 下部中央: 加速/減速ボタン
 */
export class MobileControls {
  private input: InputManager;
  private container: HTMLElement;
  private joystickManager: nipplejs.JoystickManager | null = null;

  // ジョイスティックの現在値（-1〜1）
  private joyX = 0;
  private joyY = 0;

  // ジョイスティック感度（mouse移動量相当に変換）
  private readonly SENSITIVITY = 8;

  constructor(input: InputManager) {
    this.input = input;
    this.container = document.getElementById('mobile-controls')!;

    if (!input.isMobile) {
      this.container.style.display = 'none';
      return;
    }

    this.container.style.display = 'block';
    this.setupJoystick();
    this.setupButtons();
  }

  private setupJoystick(): void {
    const zone = document.getElementById('joystick-zone')!;

    this.joystickManager = nipplejs.create({
      zone,
      mode: 'static',
      position: { left: '80px', bottom: '100px' },
      size: 120,
      color: 'rgba(0,255,136,0.35)',
      restOpacity: 0.5,
    });

    this.joystickManager.on('move', (_evt, data) => {
      if (data.vector) {
        // nipplejs: x=-1..1 (左右), y=-1..1 (上下)
        this.joyX = data.vector.x;
        this.joyY = -data.vector.y; // 画面Y反転 → 上にスティック = 上ピッチ
      }
    });

    this.joystickManager.on('end', () => {
      this.joyX = 0;
      this.joyY = 0;
    });
  }

  private setupButtons(): void {
    // 各ボタンにtouchstart/touchendイベントを設定
    this.bindButton('btn-vulcan',  'KeyF');
    this.bindButton('btn-missile', 'Space');
    this.bindButton('btn-boost',   'ShiftLeft');
    this.bindButton('btn-accel',   'KeyW');
    this.bindButton('btn-decel',   'KeyS');
    this.bindButton('btn-target',  'Tab');
  }

  private bindButton(elementId: string, keyCode: string): void {
    const btn = document.getElementById(elementId);
    if (!btn) return;

    btn.addEventListener('touchstart', (e) => {
      e.preventDefault();
      this.input.setTouchKey(keyCode, true);
      btn.classList.add('active');
    }, { passive: false });

    btn.addEventListener('touchend', (e) => {
      e.preventDefault();
      this.input.setTouchKey(keyCode, false);
      btn.classList.remove('active');
    }, { passive: false });

    btn.addEventListener('touchcancel', () => {
      this.input.setTouchKey(keyCode, false);
      btn.classList.remove('active');
    });
  }

  /** 毎フレーム呼ぶ: ジョイスティック値 → InputManager に反映 */
  update(): void {
    if (!this.input.isMobile) return;
    this.input.setTouchAxis(
      this.joyX * this.SENSITIVITY,
      this.joyY * this.SENSITIVITY,
    );
  }

  show(): void {
    if (this.input.isMobile) this.container.style.display = 'block';
  }

  hide(): void {
    this.container.style.display = 'none';
  }
}
